import { render, staticRenderFns } from "./outputSetting.vue?vue&type=template&id=a2b9154e&scoped=true"
import script from "./outputSetting.vue?vue&type=script&lang=js"
export * from "./outputSetting.vue?vue&type=script&lang=js"
import style0 from "./outputSetting.vue?vue&type=style&index=0&id=a2b9154e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b9154e",
  null
  
)

export default component.exports